import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

export const VENDOR_TARGET_KIND = "vendor";
export const FULFILL_VENDOR_TARGET_KIND = "fulfillVendor";

export const VENDORS_BASE_PATH = "/produce/purchasing/vendors";
const FULFILL_VENDORS_BASE_PATH = "/fulfill/purchasing/vendors";

export const VENDORS_DOCK_PAGE_ID = "vendors";
export const FULFILL_VENDORS_DOCK_PAGE_ID = "purchasing-vendors";

const VENDOR_ROUTE_PATTERN = /^\/produce\/purchasing\/vendors\/([^/?#]+)$/;
const FULFILL_VENDOR_ROUTE_PATTERN = /^\/fulfill\/purchasing\/vendors\/([^/?#]+)$/;

export const isVendorsRoute = (pathname: string): boolean =>
	pathname === VENDORS_BASE_PATH || pathname.startsWith(`${VENDORS_BASE_PATH}/`);

const matchVendorRoute = (pattern: RegExp, targetKind: string, pathname: string): ContinuationTarget | null => {
	const match = pattern.exec(pathname);
	if (!match) return null;
	try {
		return { targetId: decodeURIComponent(match[1]), targetKind };
	} catch {
		return null;
	}
};

export const matchVendorReceiverRoute = (pathname: string): ContinuationTarget | null =>
	matchVendorRoute(VENDOR_ROUTE_PATTERN, VENDOR_TARGET_KIND, pathname);

export const matchFulfillVendorReceiverRoute = (pathname: string): ContinuationTarget | null =>
	matchVendorRoute(FULFILL_VENDOR_ROUTE_PATTERN, FULFILL_VENDOR_TARGET_KIND, pathname);

export const fulfillVendorReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: ({ targetId }) => `${FULFILL_VENDORS_BASE_PATH}/${encodeURIComponent(targetId)}`,
	matchesRoute: matchFulfillVendorReceiverRoute
};

const vendorReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: ({ targetId }) => `${VENDORS_BASE_PATH}/${encodeURIComponent(targetId)}`,
	matchesRoute: matchVendorReceiverRoute
};

export default vendorReceiverIdentityAdapter;
